export default __webpack_public_path__ + "img/pick-date.0d9e759e.svg";